import type { IV1PageDataOfferCardResponse } from 'shared/repositories/dailyrent/entities/response/V1PageDataOfferCardResponse';

import type { ITypedReduxAction } from '../../types/redux';

export enum EDailyrentDataActionTypes {
  Fetched = 'dailyrentData/fetched',
}

export type TDailyrentDataFetched = ITypedReduxAction<
  EDailyrentDataActionTypes.Fetched,
  IV1PageDataOfferCardResponse | null
>;

export type TDailyrentDataActions = TDailyrentDataFetched;
